__turbopack_context__.v({
  "interactive-group": "_6lau3W_interactive-group",
  "interactive-group__tertiary": "_6lau3W_interactive-group__tertiary",
  "interactive-group__tertiary--narrow": "_6lau3W_interactive-group__tertiary--narrow",
});
